import React, { memo, useEffect, useState } from 'react';
import styles from './NestedTableRow.module.scss';
import LayeredTable from '../../layeredTable/LayeredTable/LayeredTable';
import ExpandButton from '../../../ExpandButton/ExpandButton';
import { useDispatch, useSelector } from 'react-redux';
import { setExpandAllAction } from '../../../../store/actions/actions';

const NestedTableRow = ({
  rowDataPropertiesArray,
  data,
  innerLightTheme = false,
  outerLightTheme = false,
  clickHighlighted,
  rowOnClick,
  expandedRowContent,
  onEditRow,
  onDeleteRow,
  isEditing,
  officeData,
}) => {
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(false);
  const expandedAll = useSelector((state) => state.officesStore.expandAllRows);
  const { CanCreateOffice, CanDeleteOffice } = useSelector(
    (store) => store.authentication.userInfo
  );

  useEffect(() => {
    if (expandedAll) {
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
    }
  }, [expandedAll]);

  const clickToggleExpand = () => {
    dispatch(setExpandAllAction(false));
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={styles.nestedTableRow}
      style={{ background: outerLightTheme ? 'white' : '#F3F7FC' }}
    >
      <div className={styles.rowHeader} onClick={clickToggleExpand}>
        <div className={styles.rowName}>
          <div className={styles.highlight}>{officeData.number}</div>
          <div className={styles.highlight}>{officeData.name}</div>
        </div>
        <ExpandButton isExpanded={isExpanded} />
      </div>
      {isExpanded && (
        <LayeredTable
          rootClassName={styles.layeredTableContainer}
          officeData={officeData}
          data={data}
          lightTheme={innerLightTheme}
          rowDataPropertiesArray={rowDataPropertiesArray}
          expandable={'start'}
          clickHighlighted={clickHighlighted}
          rowOnClick={rowOnClick}
          editable={CanCreateOffice}
          deletable={CanDeleteOffice}
          expandedRowContent={expandedRowContent}
          onEditRow={onEditRow}
          onDeleteRow={onDeleteRow}
          isEditing={isEditing}
        />
      )}
    </div>
  );
};

export default memo(NestedTableRow);
